import React from 'react'

export const useDebounce = (callback, delay, dependency = []) => {
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      callback()
    }, delay)
    return () => clearTimeout(timeout)
  }, dependency)
}
